//token user login actions
export const SET_USER_TOKEN_DATA = "SET_USER_TOKEN_DATA";
export const REMOVE_USER_TOKEN_DATA = "REMOVE_USER_TOKEN_DATA";
export const SET_SELF_USER_DATA = "SET_SELF_USER_DATA";
export const REMOVE_USER_DATA = "REMOVE_USER_DATA";

export const SET_BATTERY_USER = "SET_BATTERY_USER";
